<template>
<div>
  <Header/>
  <Navigationzj/>
  <div class="hxq_subpage">
    <div class="zmpp_con w1200">
      <div class="hxq_yzjk_mbx" style="padding-left: 0px">
        <a href="/" class="allResult">首页<span class="newspan">></span></a>帮助中心
      </div>
      <div class="demo-image__preview" style="width:100%;display: inline-block;">
        <!--左侧导航开始-->
        <div>
          <LeftNavs :leftNavis='18'/>
        </div>
        <!--左侧导航结束-->
        <div class="cght_htmainrights">
          <div class="loading-wrap">
            <div class="content-title-wrap">
              <div class="content-title">联系我们</div>
            </div>
            <div class="loading-box">
              <div class="n_right_line">
                <div class="n_title_line">
                  <div class="icon-background">
                    <div class="icon-content"><i class="el-icon-office-building"></i></div>
                  </div>
                  <div class="n_right_head">
                    <p>联系方式</p>
                  </div>
                </div>
                <div class="contact-us-content">
                  <div class="contact-method-wrap">
                    <div class="contact-method">
                      <div class="contact-method-head">在线客服</div>
                      <div class="contact-method-content">在线解答</div>
                      <div class="contact-method-content">随时随地询问，更高效更便捷</div>
                      <router-link class="service-btn find-service-btn ask-udesk" :to="{path:'/Service'}" title="在线客服">在线客服</router-link>
                    </div>
                    <div class="contact-method">
                      <div class="contact-method-head">电话客服</div>
                      <div class="contact-method-content">致电客服，人工解答</div>
                      <div class="contact-method-content">客服热线：400-040-7890</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="n_right_line">
                <div class="n_title_line">
                  <div class="icon-background">
                    <div class="icon-content"><i class="el-icon-office-building"></i></div>
                  </div>
                  <div class="n_right_head">
                    <p>我们的位置</p>
                  </div>
                </div>
                <div class="n_content">
                  <baidu-map class="bm-view" ak="wToae34mLuTbeQmttHCOfGjvuiFPl3NK" :center="center" :zoom="zoom" @ready="handler" :dragging="true" :scroll-wheel-zoom="true">
                    <!--比例尺-->
                    <bm-scale anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-scale>
                    <!--地图类型-->
                    <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type>
                    <!--点-->
                    <bm-marker :position="{lng: 111.68122, lat: 40.814849}" :dragging="true" @click="infoWindowOpen">
                      <!-- <bm-label :show="titleshow" content="志鹏供应链（内蒙古）有限公司" :labelStyle="{color: 'red', fontSize : '14px'}" :offset="{width: -70, height: 30}"/> -->
                      <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen"><h3 style="color:#436aa6;font-weight: bold;">志鹏供应链（内蒙古）有限公司</h3><p>地址：内蒙古自治区呼和浩特市赛罕区锡林南路与地质局南街交汇处未名楼A段1层1-0</p></bm-info-window>
                    </bm-marker>
                    <!--地图右下角加入定位控件-->
                    <!-- <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation> -->
                    <!--缩放-->
                    <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-navigation>
                    <!--城市列表-->
                    <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT" :offset="{width: 10, height: 40}"></bm-city-list>
                  </baidu-map>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer/>
</div>
</template>
<script>
import Header from '@/components/Header'
import Navigationzj from '@/components/Navigationzj'
import Footer from '@/components/Footer'
import LeftNavs from '@/components/Help/Left_navs'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import {BmScale, BmMapType, BmMarker, BmLabel, BmInfoWindow, BmGeolocation, BmNavigation, BmCityList} from 'vue-baidu-map'

export default {
  name: 'Help',
  components: {
    Header,
    Navigationzj,
    Footer,
    LeftNavs,
    BmScale,
    BaiduMap,
    BmMapType,
    BmMarker,
    BmLabel,
    BmInfoWindow,
    BmGeolocation,
    BmNavigation,
    BmCityList
  },
  data () {
    return {
      center: {lng: 111.68122, lat: 40.814849},
      zoom: 20,
      show: true,
      titleshow: true
    }
  },
  mounted () {
  },
  methods: {
    handler ({BMap, map}) {
      this.center.lng = 111.68122
      this.center.lat = 40.814849
      this.zoom = 20
    },
    infoWindowClose () {
      this.show = false
      this.titleshow = true
    },
    infoWindowOpen () {
      this.show = true
      this.titleshow = false
    }
  }
}
</script>
<style scoped>
.cght_htmainrights .loading-wrap {
  margin-left: 252px;
  top: 0;
  left: 0;
  right: 0;
}
.loading-wrap .content-title-wrap {
  height: 42px;
  background: #f7f7f7;
}
.loading-wrap .content-title-wrap .content-title {
  float: left;
  width: auto;
  height: 28px;
  font-size: 20px;
  font-weight: 400;
  color: #666;
  line-height: 42px;
  margin-left: 16px;
}
.loading-wrap .loading-box {
  background-size: 74px auto;
  border-left: 1px dashed #e8e8e8;
  margin-left: 43px;
  margin-top: 25px;
  margin-bottom: 40px;
  height: auto;
}
.n_right_line {
  padding-bottom: 40px;
}
.n_right_line .n_title_line {
  text-align: left;
  margin-left: -30px;
}
.n_right_line .n_title_line .icon-background {
  float: left;
  margin-left: 10px;
  margin-right: 11px;
  width: 40px;
  height: 40px;
  background-color: #436aa6;
  border-radius: 50%;
}
.loading-wrap .loading-box :last-child {
  padding-bottom: 0;
}
.n_right_line .n_title_line .icon-background .icon-content {
  text-align: center;
  line-height: 40px;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
}
.n_right_line .n_title_line .n_right_head {
  display: inline-block;
  margin-left: 21px;
  margin-top: 10px;
}
.n_right_line .n_title_line .n_right_head p {
  font-size: 18px;
  color: #333;
  line-height: 20px;
  margin-bottom: 6px;
}
.n_right_line .n_title_line .n_right_head span {
  display: inline;
  font-size: 14px;
  color: #666;
  line-height: 20px;
}
.n_right_line .n_content {
  margin-top: 20px;
  margin-left: 45px;
  text-align: left;
}
.n_right_line .n_content img {
  width: 855px;
}
.n_right_line .contact-us-content {
  margin-top: 30px;
  margin-left: 45px;
}
.n_right_line .contact-us-content .contact-method-wrap {
  height: 200px;
  background-color: #f8f8f8;
  text-align: left;
}
.n_right_line .contact-us-content .contact-method-wrap .contact-method {
  float: left;
  width: 350px;
  margin-left: 50px;
}
.n_right_line .contact-us-content .contact-method-wrap .contact-method .contact-method-head {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  line-height: 24px;
  margin: 27px auto 16px;
}
.n_right_line .contact-us-content .contact-method-wrap .contact-method .contact-method-content {
  font-size: 16px;
  font-weight: 400;
  color: #666;
  line-height: 24px;
}
.n_right_line .contact-us-content .contact-method-wrap .contact-method .ask-udesk {
  display: block;
  width: 120px;
  height: 40px;
  background: #436aa6;
  border-radius: 4px;
  margin-top: 16px;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  color: #fff;
}
.bm-view {
  width: 100%;
  height: 540px;
}
</style>



// WEBPACK FOOTER //
// src/view/help/contactus.vue